enum ProductCategory {
  DIGESTATE,
  OTHERS
}

export enum ProductCategoryLabel {
  DIGESTATE = 'Digestate',
  OTHERS = 'Others'
}

export default ProductCategory
